var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExchangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_356_318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.3599 23.8499V26.8666C31.3599 27.8247 31.5513 28.6285 31.9289 29.2548C32.4499 30.119 33.305 30.6143 34.2759 30.6143C35.2271 30.6143 36.1724 30.1511 37.0852 29.2383L47.0489 19.2746C49.2365 17.0869 49.2365 13.5274 47.0489 11.3397L37.0852 1.37604C36.1724 0.462799 35.2271 0 34.2759 0C32.8243 0 31.3599 1.15906 31.3599 3.74771V6.48743C17.2141 7.32285 5.50359 18.1787 3.76318 32.3918C3.66567 33.1856 4.11703 33.9455 4.86089 34.2398C5.07147 34.3231 5.29073 34.3634 5.50726 34.3634C6.05566 34.3634 6.58758 34.1066 6.92632 33.6438C11.5946 27.2653 19.09 23.4572 26.9764 23.4572C28.4376 23.4572 29.907 23.589 31.3599 23.8499Z",
    fill: "#5AB43A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1078 25.7602C54.364 25.4654 53.5153 25.7108 53.0424 26.3567C48.3746 32.7347 40.8792 36.5428 32.9928 36.5428C31.5316 36.5428 30.0622 36.411 28.6093 36.1501V33.1334C28.6093 30.5447 27.1444 29.3857 25.6933 29.3857C24.7421 29.3857 23.7968 29.8489 22.8836 30.7622L12.9199 40.7254C10.7327 42.9131 10.7327 46.4726 12.9203 48.6607L22.8836 58.624C23.7968 59.5372 24.7421 60 25.6933 60C27.1444 60 28.6093 58.841 28.6093 56.2523V53.5126C42.7555 52.6772 54.4656 41.8213 56.206 27.6087C56.3035 26.8144 55.8522 26.0545 55.1078 25.7602Z",
    fill: "#BDE1B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_356_318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchangeIcon);
export default __webpack_public_path__ + "static/media/exchangeIcon.6c4d87a19f0b1478129b6ddb7f803a92.svg";
export { ForwardRef as ReactComponent };